import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, Link } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import { years_list } from "../../Shared/List";
import SelectField from "../../Shared/SelectField"
import { FaFileExport } from "react-icons/fa"
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const LocationIOSummary = () => {
    const [errors, setErrors] = useState({});
    const [data, setData] = useState([]);
    const [yearOption, setYearOption] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle]  = useState('');
    const gridRef = useRef();
    const navigate = useNavigate()

    const currentYear = new Date().getFullYear();
    const [formData, setFormData] = useState({
        year: currentYear,
    })
    const {year} = formData

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/locations/io/summary?year=${payload.year}`)
            const years = []

            years_list.map(year => (
                years.push({
                    id: year.id,
                    key: year.key,
                    name: year.name
                })
            ))

            setData(response?.data);
            setYearOption(years);
            setIsLoading(false);

        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error?.response?.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to fetch IO summary')
            }
        }
    }

    useEffect(() => {

        fetchData({year})
        setTitle(`${year} Location In/Out Summary Report`)
    }, [])

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },

        {
            headerName: "Month",
            field: "month",
            sortable: true,
            filter: true,
        },
        {
            headerName: "New",
            cellRenderer: (e) => {
                if (!e.data) return null;
                const count = e.data.new;
                return count > 0 ? (
                    <Link
                        to="/location-io-new"
                        state={{
                            payload: {
                                year: year,
                                month: e.data.month_index
                            }
                        }}
                        title="View new locations"
                    >
                        {count}
                    </Link>
                ) : (
                    <span>{count}</span>
                );
            },
            sortable: false,
            filter: false,
        },
        {
            headerName: "Reconnected",
            cellRenderer: (e) => {
                if (!e.data) return null;
                const count = e.data.reconnected;
                return count > 0 ? (
                    <Link
                        to="/location-io-reconnected"
                        state={{
                            payload: {
                                year: year,
                                month: e.data.month_index
                            }
                        }}
                        title="View reconnected locations"
                    >
                        {count}
                    </Link>
                ) : (
                    <span>{count}</span>
                );
            },
            sortable: false,
            filter: false,
        },
        {
            headerName: "Disconnected",
            cellRenderer: (e) => {
                if (!e.data) return null;
                const count = e.data.disconnected;
                return count > 0 ? (
                    <Link
                        to="/location-io-disconnected"
                        state={{
                            payload: {
                                year: year,
                                month: e.data.month_index
                            }
                        }}
                        title="View disconnected locations"
                    >
                        {count}
                    </Link>
                ) : (
                    <span>{count}</span>
                );
            },
            sortable: false,
            filter: false,
        }
    ], [year]);

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))

    }

    const onSubmit = (e) => {
        e.preventDefault()
        fetchData({year})
        setTitle(`${year} Location In/Out Summary Report`)
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-2">
                    <SelectField
                        name="year"
                        value={parseInt(year)}
                        options={yearOption}
                        onChange={onChange}
                        error={errors.year}
                    />
                </div>
                <div className="col-md-8">
                    <input type="submit" className="btn btn-info mt-1" value="Apply Filter" style={{float: 'left'}}/>
                </div>
                <div className="col-md-2">
                    <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
                </div>
            </div>
            <br/>
        </form>
        <div className="card mt-0">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                    <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            suppressMenuHide={true}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}

                            rowData={data}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            pagination={false}
                            onGridReady={onGridReady}

                            resizable={true}
                            animateRows={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}

                            ref={gridRef}
                            getRowStyle={getRowStyle}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
            </div>
        </div>
      <br/>
    </>
  )
}

export default LocationIOSummary